<div class="d-flex align-items-center">
    <input
        [id]="id"
        [checked]="checked"
        (change)="onChange($event)"
        (blur)="onBlur()"
        [disabled]="disabled"
        [class.is-invalid]="invalid"
        class="form-check-input"
        type="checkbox"
    />
    <label [for]="id" (click)="onLabelClick($event)" class="form-check-label ms-1">{{ label }}</label>
</div>
